
import React from 'react';
import Chart from 'react-apexcharts';

interface GraficoAreaProps {
  series: {
    name: string;
    data: number[];
  }[];
  options?: {
    title?: {
      text?: string;
    };
    colors?: string[];
    dataLabels?: {
      enabled?: boolean;
    };
    theme?: {
      mode?: 'dark' | 'light' | undefined;
    };
  };
}

const GraficoArea: React.FC<GraficoAreaProps> = ({ series, options = {} }) => {
  return (
    <React.Fragment>
      <Chart
        type='area'
        height={250}
        series={series}
        options={{
          title: {
            text: options.title?.text,
          },
          colors: options.colors,
          dataLabels: { enabled: options.dataLabels?.enabled },
          theme: {
            mode: options.theme?.mode,
          },          
        }}
      />
    </React.Fragment>
  );
};

export default GraficoArea;
